module.exports = __webpack_public_path__ + "img/step6.df6d6a98.png";